import {useLocalStorage} from "@vueuse/core/index";
import {type Ref} from "vue";

export interface IAppConst {
    authenticated: Ref<boolean>,
}

const storage = useLocalStorage('authenticated', false)
export const useIsAuthenticated = (): IAppConst => {
    return {
        authenticated: storage
    }
}
